import { fetchGet } from '@cmd/ui-utilities';
import { TOKEN_ENDPOINT } from './logiUtils';
export const getLogiToken = async (orgId) => {
    const params = {
        selectedOrgId: orgId,
        account: 'PROD',
    };
    const response = await fetchGet(TOKEN_ENDPOINT, '', params, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};
// window.initComposerEmbedManager is enabled by including a script tag pointing to the Logi embed script
// This version of the function is a singleton and automatically refreshes the token by calling getToken when the
// current token has one minute left before expiring, so we don't have to worry about token refresh ourselves.
// We have to use this version because the npm package logi-embed's version, initEmbedManager, does not automatically
// refresh the token. It also does not send out the composer-unauthorized event described by the Logi docs.
// Because of this, we would have to implement clunky logic to check token age and that seems less practical than
// asking Logi to improve their npm package.
// Note that logi-embed is still included as a dependency so that we can use the typings it provides.
// @ts-ignore
const createOrGetEmbedManager = async (orgId) => window.initComposerEmbedManager({
    getToken: () => getLogiToken(orgId).then((result) => ({
        access_token: result.access_token,
        expires_in: result.expires_in,
    })),
});
// The EmbedManager singleton cannot handle concurrent createComponent calls — serialize them with a render queue.
// Uncomment and restore when multi-dashboard select is re-enabled.
// let renderQueue: Promise<void> = Promise.resolve();
export const renderLogiComponent = async (config, componentElementId, orgId) => {
    // const result = renderQueue.then(async () => {
    const embedManager = await createOrGetEmbedManager(orgId);
    const component = await embedManager.createComponent('dashboard', config);
    const element = document.getElementById(componentElementId);
    if (!element) {
        throw new Error(`Logi container element '${componentElementId}' not found`);
    }
    // StrictMode double-invokes effects on mount in development, so renderLogiComponent can run twice
    // for the same container — clear any previous render first to avoid stacking duplicate dashboards.
    element.replaceChildren();
    // EmbeddedDashboard.render requires width/height attributes (unlike the base EmbeddedComponent type) —
    // omitting them causes Logi's internal section-switching logic to throw on undefined.
    component.render(element, { width: '100%', height: '100%' });
    return component;
    // });
    // Keep the queue moving even if this render fails
    // renderQueue = result.then(() => {}, () => {});
    // return result;
};
export const publishFilters = async (field, message, orgId) => {
    const embedManager = await createOrGetEmbedManager(orgId);
    embedManager.publish(field, message);
};
